
















































/** @format */

import { Vue, Component, Watch, Mixins } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { PARKING_LOT_LIST } from '../router-names';
// import { Getter, Action } from 'vuex-class'
// import { IFieldInfoListItem } from '@/types/component'
import moment from 'moment';
// import ParkingLotSearch from '../../../components/parking-lot-search/index.vue'
import AddEditAreaList from '../area-list/components/add-edit-area-list.vue';
import AddEditPark from './components/add-edit-park.vue';
import AddEditChannelList from '../channel-list/components/add-edit-channel-list.vue';
// axios请求
import { deleteChannelList } from '@/api/parking-lot-management/index';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
// @Component
@Component({
  components: { AddEditAreaList, AddEditChannelList, AddEditPark }
})
export default class ParkingLotListCreate extends Vue {
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  path = '/smart-parking/parking-lot-management/parking-lot-list/';
  parkFormData: any = {}; //步骤一车场的信息
  areaFormDataList: any[] = []; //步骤二的信息
  channelFormData = {}; //步骤三的信息
  // formData = {} //区域添加
  // initData = {} // 详情展示信息
  // isDisabled: boolean = true
  isEdit: boolean = false;
  parkId = '';
  parkName = '';
  // 步骤条
  current: number = 0;
  steps: any = [
    {
      title: '创建车场',
      content: '创建车场'
    },
    {
      title: '创建区域',
      content: '创建区域'
    },
    {
      title: '创建通道',
      content: '创建通道'
    }
  ];

  // 当前标题
  get headTitle() {
    return `${this.parkId ? '编辑' : '添加'}车场`;
  }
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '车场信息',
        location: {
          name: PARKING_LOT_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }

  // 判断下一步是否禁用
  get getDisabled() {
    if (this.areaFormDataList.length > 0) {
      return false;
    } else {
      return true;
    }
  }
  // 监听步骤
  // @Watch('current', { deep: true })
  // dataChanged(val: string) {
  //   console.log(val)
  // }
  @Action('organizations/fetchUserParkingIot')
  fetchUserParkingIot(params?: { force: boolean }) {} // 获取车场信息

  // 步骤一车场提交
  isParkSubmit(values: any) {
    // console.log(values)
    this.parkId = values.parkId;
    this.parkFormData = values;
    this.current++;
    this.fetchUserParkingIot({ force: true });
  }
  // 步骤二
  isareaSubmit(values: any) {
    // console.log(values)
    this.areaFormDataList.push(values);
    console.log(this.areaFormDataList);
  }
  // 步骤三

  // 步骤条
  // 下一步
  next() {
    this.current++;
    this.isEdit = false;
  }
  // 上一步
  prev() {
    this.current--;
    if (this.current === 0) {
      this.isEdit = true;
      this.parkFormData.parkId = this.parkId;
      console.log(this.parkFormData);
    }
  }
  // 三步都完成
  finish() {
    this.$message.success('添加成功');
    this.current = 0;
    this.goBack();
  }
  /**
   * 返回
   */
  goBack() {
    // 清除当前tab页签
    this.closeCurrentTab();
    this.$router.replace({
      name: PARKING_LOT_LIST
    });
  }
}
